import { render } from "./fiveTreeSelect.vue?vue&type=template&id=9671852a"
import script from "./fiveTreeSelect.vue?vue&type=script&lang=js"
export * from "./fiveTreeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__